module.exports = __webpack_public_path__ + "img/nav-video-home-act.24258695.png";